module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-redis-02-m-en.72c6c0deea52bf5ea4d316666a5d383e.png";